(function () {
    const searchDropdown = document.getElementById("search-dropdown")
    if (!searchDropdown) return;
    searchDropdown.addEventListener("show.bs.collapse", function () {
        searchDropdown.querySelector("#search-input").focus()
    })
})();